import { SegmentedControl } from '@mantine/core';
import { IconClick, IconEye } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { recordTypeAtom } from '~/atoms/recorder-atoms';
import clsx from 'clsx';

const recordTypeOptions = [
  {
    label: (
      <div className="flex items-center space-x-1">
        <IconClick size={12} />
        <div className="text-xs">Act</div>
      </div>
    ),
    value: 'action',
  },
  {
    label: (
      <div className="flex items-center space-x-1">
        <IconEye size={12} />
        <div className="text-xs">Assert</div>
      </div>
    ),
    value: 'assertion',
  },
];

export function RecordTypeIndicator({ className }: { className?: string }) {
  const [recordType, setRecordType] = useAtom(recordTypeAtom);
  return (
    <SegmentedControl
      value={recordType}
      onChange={setRecordType}
      className={clsx('w-full', className)}
      data={recordTypeOptions}
    />
  );
}
